import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="footer-card">
        <div className="footer-title">Disclaimer & Support</div>
        <p className="footer-text">
          WM provides live activity streaming tools. Always follow local laws, road rules, and
          safety guidance while recording or sharing activities.
        </p>
        <div className="footer-links">
          <Link to="/help">Help & Support</Link>
          <Link to="/legal">Legal Notice</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
